import { render, staticRenderFns } from "./pricing-plan-list.vue?vue&type=template&id=ced41ace&"
import script from "./pricing-plan-list.vue?vue&type=script&lang=js&"
export * from "./pricing-plan-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports